module.exports = __webpack_public_path__ + "media/application/images/partners/kts@2x-90f24e2f3e5b8d4b5d5759c6db01224a29bf1e05fcf9b4eebf8c6e9ff9627320.png";